import * as types from '../../types'
import {
    API_URL
} from '../../utils/constants'
import {
    displayMessages,
    setSavingState
} from '../Layout/actions'
import {
    createAxiosInstance,
    validateModel
} from '../../utils/helpers'
import {
    tableActions
} from '@mawesi-sas/mws_react_component_table';


export function reiniciarEstado() {
    return (dispatch) => {
        dispatch({
            type: types.SOLICITUDES_REINICIAR_ESTADO
        })
    }
}

export function getDataFromServer(page = 1) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const modelo = 'Solicitud'
        const include = ['solicitante', 'detalles', 'distribuciones.cenco.aprobador']
        const take = 100
        const filter = getState().solicitudes.getIn(['filter'])
        const fields = ['id', 'evento_actividad', 'nombre_cafeteria', 'fecha_hora', 'lugar', 'estado', 'solicitante.name', 'distribuciones.cenco.codigo']
        const filters = []

        if (filter) {
            fields.forEach(x => {
                let f = {
                    field: x,
                    operator: 'like',
                    value: filter
                }
                filters.push(f)
            })
        }
        const skip = (page - 1) * take
        axios.get(`${API_URL}/solicitudes`, {
                params: {
                    modelo,
                    filters,
                    include,
                    skip,
                    take,
                    orderBy: {
                        field: 'id',
                        direction: 'desc'
                    },
                    total: true
                }
            })
            .then((res) => {
                const list = res.data.data.map(x => {
                    x._enabled = true
                    return x
                })
                const records = res.data.total
                dispatch(tableActions.mswTable_mostrarDatos('solicitudes', 'solicitudes', list, page, records))
            })
            .catch((err) => {
                console.log(err);
                displayMessages(dispatch, err)
            })
    }
}

export function showHideModalEditStatus(show) {
    return (dispatch) => {
        dispatch({
            type: types.SOLICITUDES_MOSTRAR_MODAL_MODICAR_ESTADO_SOLICITUDES,
            payload: {
                show
            }
        })

    }
}

export function modificarEstadoSolicitudesSeleccionadas() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const seleccion = getState().solicitudes.getIn('solicitudes.data'.split('.')).valueSeq().filter(x => x.get('selected')).map(x => x.get('id'))
        const estado = getState().solicitudes.getIn('modalEditStatus.data.estado'.split('.'))
        const data = {
            solicitudes: seleccion,
            estado
        }
        axios.put(`${API_URL}/solicitudes/estado`, data)
            .then((res) => {
                displayMessages(dispatch, {
                    success: 'El estado de las solicitudes ha sido actualizado exitosamente'
                })
                dispatch(showHideModalEditStatus(false))
                dispatch(getDataFromServer())
            })
            .catch((err) => {
                console.log(err);
                displayMessages(dispatch, err)
            })
    }
}